import React from 'react';

import VideoPlayer from '../../../components/videoComponents/VideoPlayer';
import LockedVideo from '../../../components/videoComponents/LockedVideo';
import { capitalizeFirstChar } from '../../../utils/helpers';
import hollywoodXposedBcg from '../../../assets/hollywoodXposedSegment/hollywoodxposed-background-image.png';
import topSponsoredLogo from '../../../assets/hollywoodXposedSegment/top_logo.png';
import bannerDesktopLogo from '../../../assets/hollywoodXposedSegment/desktop/desktop-logo_banner.png';
import bannerMobileLogo from '../../../assets/hollywoodXposedSegment/mobile/mobile-logo_banner.png';

import fetchVideoSegment from './fetchVideoSegmentService';
import constructAffiliateLink from './constructHollywoodXposedAffiliateLink';

import './css/ArchivesVideoPlayer.css';
import './css/ArchivesVideoPlayer.mobile.css';
import ArchivesPromotionBanner from './ArchivesPromotionBanner';


class ArchivesVideoPlayer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ready: this.props.searchSegmentId !== '219',
      videoIsFree: false,
    };
    this.queryParams = new URLSearchParams(props.location.search);
    this.affiliatePartnerCode = this.queryParams?.get('affiliatePartnerCode');
    this.affiliatePartnerOfferCode = this.queryParams?.get('affiliatePartnerOfferCode') || '';
  }

  async componentDidMount() {
    if (this.props.searchSegmentId === '219' || this.affiliatePartnerCode) {
      const { data } = await fetchVideoSegment(this.props.programSegmentId, this.affiliatePartnerCode);
      const newState = { ready: true };
      if (data.data.clip.clipUrls) {
        newState.videoIsFree = true;
      }
      this.setState(newState);
    } else {
      this.setState({ ready: true });
    }
  }

  getTitle = () => {
    const title = this.props.videoElement && this.props.videoElement.name ? this.props.videoElement.name : (this.props.videoElement.slug ? this.props.videoElement.slug.replace(/(-w\d{1,})/, '').
      replace(/(-v(\d)*)/, '').
      replace(/(\d\d\d\d-)/, '').
      replace(/(\d\d\d\d\/\d\d)/, '').
      replace(/(\/nude-program)/, '').
      replaceAll('-', ' ') : 'Archives');

    return `${capitalizeFirstChar(title)} | Naked News`;
  };

  render() {
    const { ready, videoIsFree } = this.state;
    const {
      user,
      videoElement,
      typeOfListing,
      showSegmentList,
      searchAnchorId,
      searchSegmentId,
    } = this.props;

    const isSubscribed = user.user && user.user.activeSubscription;
    const isHollywoodXposedSegment = searchSegmentId === '219';
    const isFreeForAffiliate = this.affiliatePartnerCode?.length;

    let isVideoAvailable = false;
    if (isHollywoodXposedSegment || isFreeForAffiliate) {
      if (videoIsFree) {
        isVideoAvailable = true;
      }
    } else if (isSubscribed) {
      isVideoAvailable = true;
    }
    const showLocked = videoElement.programSegmentId !== '';

    const videoPlayerElement = (
      <VideoPlayer
        key={videoElement.programId ? videoElement.programId : videoElement.id}
        customBcgColor="transparent"
        forceHideNextSegmentButton={isHollywoodXposedSegment}
        hidePlayerInfo={isHollywoodXposedSegment}
        isProgram={showSegmentList}
        searchAnchorId={searchAnchorId}
        searchSegmentId={searchSegmentId}
        takeFullWidth={true}
        typeOfListing={typeOfListing}
        user={user}
        videoElement={videoElement}
      />
    );

    return ready && (
      <>
        <ArchivesPromotionBanner affiliatePartnerCode={this.affiliatePartnerOfferCode} />
        {isVideoAvailable ? (
          <>
            {isHollywoodXposedSegment ? (
              <div
                className="sponsored-segment"
                style={{ backgroundImage: `url(${hollywoodXposedBcg})` }}
              >
                <div className="sponsored-label">
                  <a
                    href={constructAffiliateLink()}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <div className="sponsored-label__logo">
                      <img alt="Mr. Skin logo" src={topSponsoredLogo} />
                    </div>
                    <div className="sponsored-label__sponsor-name">
                      Segment sponsored by Hollywood Xposed
                    </div>
                  </a>
                </div>
                {videoPlayerElement}
                <div className="sponsored-banner">
                  <a
                    href={constructAffiliateLink()}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <img
                      alt="Mr. Skin Banner Logo"
                      className="sponsored-banner__desktop-logo"
                      src={bannerDesktopLogo}
                    />
                    <img
                      alt="Mr. Skin Banner Logo"
                      className="sponsored-banner__mobile-logo"
                      src={bannerMobileLogo}
                    />
                    <p className="sponsored-banner__text">The most iconic nudity ever</p>
                  </a>
                </div>
              </div>
            ) : videoPlayerElement}
          </>
        ) : (
          showLocked && <LockedVideo typeOfListing={typeOfListing} user={user} videoElement={videoElement} />
        )}
      </>
    );
  }
}

export default ArchivesVideoPlayer;
